export function isSoloBookingBusiness(business = {}, staff = []) {
  const configured = business.noWorkers === true || business.noWorkerMode === true || business.teamMode === 'solo' || business.soloOwner === true || business.ownerOnly === true || business.businessModel === 'solo';
  const activeStaff = (Array.isArray(staff) ? staff : []).some(person => person && person.disabled !== true && person.active !== false && !person.__loopSelfFallback && !person.__soloCompanyAgenda && !person.__derivedFromBookingsV16F);
  return configured && !activeStaff;
}
